import { Modal, closeModal as pluginCloseModal, openModal as pluginOpenModal } from 'jenesius-vue-modal'
import { ModalOptions } from 'jenesius-vue-modal/dist/types/utils/Modal'
import { WrapComponent } from 'jenesius-vue-modal/dist/types/utils/types'

export const closeModal = async () => {
  try {
    await pluginCloseModal()
  } catch (e) {
    console.log(e)
  }
}

export const openModal = (
  component: string | WrapComponent,
  props?: unknown,
  options?: Partial<ModalOptions>,
): Promise<Modal> => {
  return pluginOpenModal(component, props, options)
}
